import {emailInputRegex} from "../../../../utils/globalConstants";
import {submitEvent} from "@otto-ec/tracking-bct";
import {HTMLOcButtonV1Element} from "@otto-ec/otto-components/dist-lib/components/button/v1/ButtonV1.types.g";
import {HTMLOcSheetV1Element} from "@otto-ec/otto-components/dist-lib/components/sheet/v1/SheetV1.types.g";

const newsletterSubscribeEmailRegex = emailInputRegex

let newsletterSubscribeValidForm = false;

const newsletterSubscribeForm = document.getElementById(
  "newsletter-subscribe-form"
);
newsletterSubscribeForm?.addEventListener(
  "submit",
  newsletterSubscribeOnSubmitHandler
);

const newsletterSubscribeEmailInput = document.getElementById(
  "newsletter-subscribe-email-input"
) as HTMLInputElement;
newsletterSubscribeEmailInput?.addEventListener(
  "blur",
  validateNewsletterSubscribeEmailInputHandler
);

const newsletterSubscribeError = document.getElementById(
  "newsletter-subscribe-error"
);

const newsletterSubscribeSheetCloseButton = document.querySelector<HTMLOcButtonV1Element>("#newsletter-subscribe-sheet-close-button")
const newsletterSubscribeSheet = document.querySelector<HTMLOcSheetV1Element>("#newsletter-subscribe-sheet")
newsletterSubscribeSheetCloseButton?.addEventListener("click", () => {
  newsletterSubscribeSheet?.close();
});

function validateNewsletterSubscribeEmailInputHandler() {
  const inputValue = newsletterSubscribeEmailInput?.value;
  const successFormBanner = document.getElementById("success-form-banner");
  const invalidFormBanner = document.getElementById("invalid-form-banner");


  if (inputValue.match(newsletterSubscribeEmailRegex)) {
    newsletterSubscribeEmailInput.setAttribute("validation-message", "")
    invalidFormBanner!.style.display = "none";
    newsletterSubscribeValidForm = true;
  } else if (inputValue === "") {
    newsletterSubscribeEmailInput.setAttribute("validation-message", "Bitte trage eine gültige E-Mail-Adresse ein.")
    invalidFormBanner!.style.display = "none";
    successFormBanner!.style.display = "none";
    newsletterSubscribeValidForm = false;
  } else if (inputValue.length <= 5) {
    newsletterSubscribeEmailInput.setAttribute("validation-message","Deine E-Mail-Adresse darf nicht weniger als 6 Zeichen enthalten.")
    invalidFormBanner!.style.display = "none";
    successFormBanner!.style.display = "none";
    newsletterSubscribeValidForm = false;
  } else {
    newsletterSubscribeEmailInput.setAttribute("validation-message", "Bitte überprüfe, ob deine eingegebene E-Mail-Adresse ein @-Zeichen und einen Punkt enthält.")
    invalidFormBanner!.style.display = "none";
    successFormBanner!.style.display = "none";
    newsletterSubscribeValidForm = false;
  }
}

const sendNewsletterSubscription = async (emailInput: string) => {
  const payload = {
    email: emailInput,
  };
  try {
    const response = await fetch("/newsletter-subscription/subscribe", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (response.status === 200) {
      const successFormBanner = document.getElementById("success-form-banner");
      successFormBanner!.style.display = "flex";
      newsletterSubscribeError!.style.display = "none";
      showConfirmationEmailSheet();
      trackSubmitSubscribeNlSuccess()
    } else {
      showErrorContent();
      trackSubmmitSubscribeNlFailure()
    }
  } catch (error) {
    console.error("Something went wrong:", error.message, error.name);
    showErrorContent();
  }
};

function newsletterSubscribeOnSubmitHandler(e: Event) {
  e.preventDefault();
  validateNewsletterSubscribeEmailInputHandler()
  if (newsletterSubscribeValidForm === true) {
    const payloadEmailInputVal = newsletterSubscribeEmailInput?.value;
    if (!!payloadEmailInputVal) {
      sendNewsletterSubscription(payloadEmailInputVal);
    }
  } else {
    const invalidFormBanner = document.getElementById("invalid-form-banner");
    invalidFormBanner!.style.display = "flex";
    invalidFormBanner!.style.flexDirection = "column"
  }
}

function showErrorContent() {
  newsletterSubscribeError!.style.display = "unset";
}

function showConfirmationEmailSheet() {
    newsletterSubscribeSheet.open = true;
}


/*                  */
function trackSubmitSubscribeNlSuccess() {
  submitEvent({
    user_Permission: ['Newsletter'],
    user_PermissionActivity: ['true_ok_LP'],
  });
}

function trackSubmmitSubscribeNlFailure() {
  submitEvent({
    user_Permission: ['Newsletter'],
    user_PermissionActivity: ['true_error_LP'],
  });
}
